var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-time-select',{attrs:{"picker-options":{
        step: '00:15',
    },"placeholder":_vm.config.placeholder,"clearable":""},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }